import { Injectable, inject } from '@angular/core';

import { REVIEW_STATUS, WORKFLOW_STATUS } from '@app/shared/constants/shared.constant';
import { ToastNotificationService } from '@app/shared/services/toast-notification.service';

@Injectable()
export class CommonService {
    private readonly toast = inject(ToastNotificationService);

    showToastForStatusChange(status: REVIEW_STATUS | WORKFLOW_STATUS) {
        const messageMap: { [key in REVIEW_STATUS | WORKFLOW_STATUS]?: string } = {
            [WORKFLOW_STATUS.APPROVED]: `Approved successfully`,
            [WORKFLOW_STATUS.REJECTED]: `Rejected successfully`,
            [REVIEW_STATUS.ACCEPTED]: `Accepted successfully`,
            [REVIEW_STATUS.CANCELED]: `Approval request is canceled successfully`,
            [REVIEW_STATUS.ADD_COMMENT]: 'Comment is added successfully',
            [REVIEW_STATUS.NEED_INFO]: 'Request for more information is sent',
            [REVIEW_STATUS.NEED_CHANGES]: 'Request for change is sent',
            [REVIEW_STATUS.PENDING_ACCEPTANCE]: `Sent for approval`,
        };

        return messageMap[status] ? this.toast.showSuccess(messageMap[status]) : null;
    }
}
